//@flow
import React from 'react';
import CartItem from './CartItem.react';

import type ProductsCollection from '../../Stores/Products/productsCollection';
import type QuoteItemCollection from '../../Stores/Quote/quoteItemsCollection';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type StockCollection from '../../Stores/Stock/stockCollection';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';

type Props = {
  inCart:boolean,
  products:ProductsCollection,
  quoteItems:QuoteItemCollection,
  quote:QuoteModel,
  className?:string,
  summaryOpen?:boolean,
  closeSummary?:() => void,
  lessTextMsrp?:boolean,
  strikeUnselectedPrice?:boolean,
  stock?:StockCollection,
  membershipPlan:MembershipPlanModel,
};

function _renderCartItems(props:Props) {
  if (props.quoteItems.models.length) {
    return props.quoteItems.models.map((quoteItem) => {
      return (
        <CartItem
          inCart={props.inCart}
          products={props.products}
          quoteItem={quoteItem}
          key={quoteItem.getId()}
          quote={props.quote}
          lessTextMsrp={props.lessTextMsrp || false}
          strikeUnselectedPrice={props.strikeUnselectedPrice}
          stock={props.stock}
          membershipPlan={props.membershipPlan}
        />
      );
    });
  }
}

function _getClassName(props:Props) {
  let className = props.className || 'cart-items scrollable';
  if (props.summaryOpen) className += ' mask';
  return className;
}

export default function CartItems(props:Props) {
  return (
    <div onClick={props.closeSummary} className={_getClassName(props)}>
      {_renderCartItems(props)}
    </div>
  );
}
